import { graphql } from "react-relay";

export const UpdateAccountGroupMutation = graphql`
  mutation UpdateAccountGroupMutation($input: UpdateAccountGroupInput!) {
    updateAccountGroup(input: $input) {
      group {
        accountMappings {
          edges {
            node {
              account {
                id
                key
                name
                provider
              }
            }
          }
        }
        description
        dynamicFilter
        id
        name
        regions
        uuid
      }
    }
  }
`;
